import React, { useState } from "react";

import toast from "react-hot-toast";
import dislike from "../../assets/images/dislike.png";
import like from "../../assets/images/like.png";
import { trackEvent } from "../../bridges/BridgeServices";
import "./feedbackSurvey.scss";

const FeedbackSurvey = () => {
  const [showFeedBack, setShowFeedBack] = useState(true);

  const logEvent = selection => {
    trackEvent(selection);
    setShowFeedBack(false);
    toast.success("Thank you for the feedback!");
  };

  if (!showFeedBack) {
    return null;
  }
  return (
    <div className="feedback-survey">
      <div className="text">
        Did this answer your concern ?
      </div>
      <div
        className="pos-button"
        onClick={() => {
          logEvent("yes");
        }}
      >
        <div className="pos-icon">
          <img src={like} />
        </div>
        <div className="pos-text">Yes</div>
      </div>
      <div
        className="neg-button"
        onClick={() => {
          logEvent("no");
        }}
      >
        <div className="neg-icon">
          <img src={dislike} />
        </div>
        <div className="neg-text">No</div>
      </div>
    </div>
  );
};

export default FeedbackSurvey;
